export function detectTouchDevice() {
  if (isTouchDevice()) {
    $('html').addClass('touch');
  }
}

export function isTouchDevice(): boolean {
  return (('ontouchstart' in window)
      || (navigator.maxTouchPoints > 0)
      || (navigator.msMaxTouchPoints > 0));
}
